import {
  INVALID_TASK_DEPENDENCIES,
  INVALID_TASK_FIELD_VALUES,
  INVALID_TIME_CONSTRAINT,
  LABWARE_FINAL_LOCATION_SELF_COLLISION,
  LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED,
  LABWARE_FINAL_LOCATION_SLOT_COLLISION,
  LABWARE_START_LOCATION_SELF_COLLISION,
  LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED,
  LABWARE_START_LOCATION_SLOT_COLLISION,
  MINIMUM_GRAPH_REQUIREMENTS,
  MISSING_INSTRUMENT,
  MISSING_START_LOCATION,
  MISSING_TIME_ESTIMATE,
} from '../features/workflowJsonSelectors';

export type PreviewBlockerKey =
  | typeof INVALID_TASK_DEPENDENCIES
  | typeof INVALID_TIME_CONSTRAINT
  | typeof MINIMUM_GRAPH_REQUIREMENTS
  | typeof MISSING_INSTRUMENT
  | typeof MISSING_START_LOCATION
  | typeof LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED
  | typeof LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED
  | typeof MISSING_TIME_ESTIMATE
  | typeof INVALID_TASK_FIELD_VALUES
  | typeof LABWARE_START_LOCATION_SELF_COLLISION
  | typeof LABWARE_START_LOCATION_SLOT_COLLISION
  | typeof LABWARE_FINAL_LOCATION_SLOT_COLLISION
  | typeof LABWARE_FINAL_LOCATION_SELF_COLLISION;

export type PreviewBlocker = {
  title: string;
  description: string;
  taskIds?: string[];
  labwareIds?: string[];
};

export const previewBlockers: Record<PreviewBlockerKey, PreviewBlocker> = {
  [MINIMUM_GRAPH_REQUIREMENTS]: {
    title: 'Nothing to plan:',
    description: 'Ensure that at least a task is assigned to a labware.',
  },
  [MISSING_TIME_ESTIMATE]: {
    title: 'Missing task duration:',
    description: 'Verify that timings are provided for all tasks.',
  },
  [MISSING_INSTRUMENT]: {
    title: 'Missing instrument selection:',
    description:
      'Select an instrument for every connected action task before publishing.',
  },
  [INVALID_TASK_FIELD_VALUES]: {
    title: 'Invalid task field values:',
    description: 'Ensure all fields are filled in correctly.',
  },
  [MISSING_START_LOCATION]: {
    title: 'Missing labware placement:',
    description: 'Make sure all labware have their starting location defined.',
  },
  [INVALID_TIME_CONSTRAINT]: {
    title: 'Invalid time constraint:',
    description:
      'Ensure tasks share common labware and that max duration is greater than the total duration of all tasks.',
  },
  [INVALID_TASK_DEPENDENCIES]: {
    title: 'Invalid task dependency:',
    description:
      'For each dependency, ensure both tasks are connected to different labware.',
  },
  [LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED]: {
    title: 'Labware slot capacity exceeded in starting location assignments:',
    description:
      'Ensure that the total number of labware starting locations assigned to a device does not exceed its capacity.',
  },
  [LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED]: {
    title: 'Labware slot capacity exceeded in final location resolution:',
    description:
      'Ensure that the total number of labware final locations resolving to a device does not exceed its capacity.',
  },
  [LABWARE_START_LOCATION_SELF_COLLISION]: {
    title: 'Labware starting slots overlap:',
    description:
      'Some of the starting location slots or slot ranges overlap in a single labware',
  },
  [LABWARE_START_LOCATION_SLOT_COLLISION]: {
    title: 'Labware starting slots collision:',
    description: 'Collision with starting slots of one or more other labware',
  },
  [LABWARE_FINAL_LOCATION_SLOT_COLLISION]: {
    title: 'Labware final location slots collision:',
    description:
      'Collision with final location slots of one or more other labware',
  },
  [LABWARE_FINAL_LOCATION_SELF_COLLISION]: {
    title: 'Labware final location slots overlap:',
    description:
      'Some of the final location slots or slot ranges overlap in a single labware',
  },
};
